import { render, staticRenderFns } from "./checkbox-field.vue?vue&type=template&id=e5a8a83c&scoped=true"
import script from "./checkbox-field.vue?vue&type=script&lang=ts"
export * from "./checkbox-field.vue?vue&type=script&lang=ts"
import style0 from "./checkbox-field.vue?vue&type=style&index=0&id=e5a8a83c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a8a83c",
  null
  
)

export default component.exports